import DOMPurify from 'dompurify';


function sanitizeInput(input) {
    return DOMPurify.sanitize(input, { ALLOWED_TAGS: [] });
}

export default sanitizeInput